/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ types: NonNullable<unknown> }} Spaces_Hide_Unsupported_HintInputs */



/**
* | output |
* | --- |
* | "Supported: {types}" |
*
* @param {Spaces_Hide_Unsupported_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_hide_unsupported_hint = /** @type {((inputs: Spaces_Hide_Unsupported_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Hide_Unsupported_HintInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Unterstützt: ${i?.types}`)
	return /** @type {LocalizedString} */ (`Supported: ${i?.types}`)
});